export const getProveedoresFormSteps = () => [
    { id: 0, name: "DATOS DE LA COMPAÑÍA", error: false },
    { id: 1, name: "GIROS DE LA EMPRESA", error: false },
    { id: 2, name: "DOMICILIO FISCAL", error: false },
    { id: 3, name: "INFORMACIÓN COMPLEMENTARIA", error: false },
    { id: 4, name: "ENVIAR SOLICITUD", name2: "SOLICITUD ENVIADA", name3: "GUARDAR SOLICITUD", name4: "SOLICITUD GUARDADA", error: false },
];

export const getDatosCompaniaForm = () => ({
    txtTipoPersona: {
        name: "txtTipoPersona",
        label: "Tipo de persona:",
        value: "",
        required: true,
        error: false,
        helper: "Seleccione el tipo de persona",
    },
    txtNombreContactoPrincipal: {
        name: "txtNombreContactoPrincipal",
        label: "Nombre de contacto principal:",
        value: "",
        required: true,
        error: false,
        helper: "Ingrese el nombre del contacto principal",
    },
    txtRFC: {
        name: "txtRFC",
        label: "RFC:",
        label2: "Número de registro fiscal/TAX ID:",
        value: "",
        required: true,
        error: false,
        helper: "Ingrese el RFC o Cédula de la empresa",
        helper2: "Ingrese número de registro fiscal/TAX ID",
    },
    txtTelefonoContactoPrincipal: {
        name: "txtTelefonoContactoPrincipal",
        label: "Teléfono de contacto principal:",
        value: "",
        required: true,
        error: false,
        helper: "Ingrese el teléfono de la empresa",
    },
    txtRazonSocial: {
        name: "txtRazonSocial",
        label: "Razón social:",
        value: "",
        required: true,
        error: false,
        helper: "Ingrese la razón social de la empresa",
    },
    txtCorreoContactoPrincipal: {
        name: "txtCorreoContactoPrincipal",
        label: "Correo de contacto principal:",
        value: "",
        required: true,
        error: false,
        helper: "Ingrese el correo de la empresa",
    },
    txtCobertura: {
        name: "txtCobertura",
        label: "Cobertura:",
        value: [],
        required: true,
        error: false,
        helper: "Seleccione las coberturas",
    },
    txtNumeroDUNS: {
        name: "txtNumeroDUNS",
        label: "Número D-U-N-S:",
        value: "",
        required: false,
        error: false,
        helper: "Ingrese el número D-U-N-S",
    },
    txtNumeroEmpleados: {
        name: "txtNumeroEmpleados",
        label: "Número de empleados:",
        value: "",
        required: true,
        error: false,
        helper: "Ingrese el número de empleados total",
    },
    txtRegistroPatronalIMSS: {
        name: "txtRegistroPatronalIMSS",
        label: "Registro patronal IMSS:",
        value: "",
        required: false,
        error: false,
        helper: "Ingrese el registro patronal IMSS",
    },
    txtFechaConstitucionEmpresa: {
        name: "txtFechaConstitucionEmpresa",
        label: "Fecha de constitución de la empresa:",
        value: new Date().setFullYear(new Date().getFullYear() - 2),
        required: true,
        error: false,
        helper: "Ingrese la fecha de constitución de la empresa",
    },
    txtSituacionFiscal: {
        name: "txtSituacionFiscal",
        label: "Constancia de situación fiscal (max. 10MB):",
        value: "",
        required: true,
        error: false,
        helper: "Seleccione un archivo .doc, .docx o .pdf",
    },
    txtCartaPresentacion: {
        name: "txtCartaPresentacion",
        label: "Carta de presentación (max. 10MB):",
        value: "",
        required: true,
        error: false,
        helper: "Seleccione un archivo .doc, .docx o .pdf",
    },
    txtEstructuraLegal: {
        name: "txtEstructuraLegal",
        label: "Estructura legal:",
        value: "",
        required: true,
        error: false,
        helper: "Ingrese la estructura legal",
    },
    txtSitioWeb: {
        name: "txtSitioWeb",
        label: "Sitio web:",
        value: "",
        required: false,
        error: false,
        helper: "Ingrese una url válida",
    },
    txtNombreComercial: {
        name: "txtNombreComercial",
        label: "Nombre comercial:",
        value: "",
        required: true,
        error: false,
        helper: "Ingrese el nombre comercial",
    },
});

export const getActividadPrincipalModel = () => ({
    iIdActividadEconomica: 0,
    iClave: 0,
    sDescripcion: "",
    sActividadesIncluye: "",
});
